import React from "react";
import Header from "../../../components/header/Header";
import "./Policy.css";
import { useTranslation } from "react-i18next";
import PolicyText from "./textPolicy/PolicyText";

const Policy = () => {
  const { t } = useTranslation();
  const PolicyTextGenerate = () => {
    let result = [];
    const countText = 422;
    for (let i = 1; i != countText; i++) {
      result.push(
        <>
          <p><br /></p>
          <p>{t(`policyText.policyText${i}`)}</p>
        </>
      );
    }
    return <>{result}</>;
  };

  return (
    <div className="Policy">
    <Header hasMenu2={true} />
    <div className="PolicyWrapper">
      {/* <PolicyText /> */}
        <div className="policyText">
            <h1>{t("policyText.h1")}</h1>
            {PolicyTextGenerate()}
        </div>
    </div>
  </div>
  );
};

export default Policy;
